import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-branch',
  standalone: true,
  imports: [CommonModule,RouterOutlet],
  templateUrl: './branch.component.html',
  styleUrl: './branch.component.scss'
})
export class BranchComponent {
  menuOpen = false;
  selectedTable: 'company' | 'branch' | 'user' = 'company';
  router = inject(Router);
  
  data = [
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
    { name: 'Abacus', id: 'C00001',branch:'New York City', state: 'London', branches: 10,users:10, status: 'Active', dateCreated: '04-07-2024',user:"mitchell", Role:"UW Admin"},
  ]

  selectTable(type: 'company' | 'branch' | 'user') {
    this.selectedTable = type;
  }

  openMenu() {
    this.menuOpen = true;
  }
  
  closeMenu() {
    this.menuOpen = false;
  }
 
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
  
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('#au_header_user_menu_toggle')) {
      this.menuOpen = false;
    }
  }
  addBranch(){
    this.router.navigate(['/system-admin-dashboard/branch/add-branch'])
  }
}
